import { render, staticRenderFns } from "./student-document-form.vue?vue&type=template&id=4b724d2c&"
import script from "./student-document-form.vue?vue&type=script&lang=js&"
export * from "./student-document-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports